import GearIcon from './component'

export default GearIcon
